<script setup lang="ts">
import type { NavigationMenuItem } from '#ui/types';

// PROPS
defineProps({
    items: { type: Array as PropType<NavigationMenuItem[]>, default: () => [] },
});

// EMITS
defineEmits<{
    openContactForm: [];
}>();

// DATA
const ui = {
    root: 'w-full bg-neutral-100 rounded-lg [&>div]:w-full',
    list: 'justify-center',
    item: 'py-0 grow',
    link: 'py-2 text-sm group items-center justify-center data-active:bg-primary data-active:text-inverted data-active:m-1 data-active:rounded-lg',
    linkLeadingIcon: 'group-data-active:text-inverted size-5',
};
</script>

<template>
    <UNavigationMenu :items="items" :ui="ui" class="pl-1" color="primary">
        <template #list-leading>
            <SlpFiltersAdvancedModalButton @open-contact-form="$emit('openContactForm')" />
        </template>
    </UNavigationMenu>
</template>
